export default "__VITE_ASSET__D8c7NVNN__"